import styled from 'styled-components';

import DropInContainer from 'craft/components/DropInContainer';

export default styled(DropInContainer)`
  width: 80px;
  height: 80px;
  justify-content: space-around;
  flex-direction: column;
  font-size: 0.6em;
  font-weight: 600;
  cursor: grab;
  text-align: center;

  &:active {
    cursor: grabbing;
  }
`;
